import { ReportModel } from '../../shared/models/ReportModel';
import emptySliceApi from '../../shared/store/emptyApiSlice';

interface ReportApiRequest {
  accountId: string;
  dealId: string;
  StartDate: string;
  EndDate: string;
}

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getReportDeals: builder.query<ReportModel, ReportApiRequest>({
      query: ({ accountId, dealId, StartDate, EndDate }) =>
        `/accounts/${accountId}/deals/${dealId}/reports?StartDate=${encodeURIComponent(
          StartDate,
        )}&EndDate=${encodeURIComponent(EndDate)}`,
      providesTags: ['Report'],
    }),
  }),
});

export const { useGetReportDealsQuery } = apiSlice;
